import Portal from './portal';
import styles from '../styles/message.module.scss';
import { useTimeout } from '@utils/hooks';
import { IMessage } from '@base/features/message/message';
import {container} from 'tsyringe';

export interface MessageEvent {
  type: 'info' | 'error' | 'success' | 'loading' | 'warning';
  content: string;
  onClose?: () => void;
}

export default function Message(props: { message: MessageEvent }) {
  const className = styles[props.message.type] + ' ' + styles.message;
  const messageProvider: IMessage = container.resolve('message');

  useTimeout(() => {
    props.message.onClose?.()
    messageProvider.onMessage.next(undefined);
  }, 2000);
  
  return (
    <Portal>
      <div className={className}>{props.message.content}</div>
    </Portal>
  );
}
